export const initialState = {
    statistic: null,
    isOpen: false,
};

export const initialPersistantState = {
    wasShown: false,
};